/* Restore native homepage sliders after image sizing and back/forward cache.
   No replacement library, polling, or duplicate initialization. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var selector = '.js-homepage-slideshow, [data-logo-slider], .js-product-slider .products-slider';
  var queued = false;
  var pending = false;
  function repair() {
    queued = false;
    var $ = window.jQuery;
    if (!$ || !window.loadFlickity) return;
    var nodes = Array.prototype.filter.call(document.querySelectorAll(selector), function (node) {
      return node.isConnected && node.getBoundingClientRect().width > 0;
    });
    if (!nodes.length || pending) return;
    pending = true;
    window.loadFlickity().then(function () {
      nodes.forEach(function (node) {
        if (!node.isConnected || node.getBoundingClientRect().width <= 0) return;
        var instance = window.Flickity && window.Flickity.data(node);
        if (!instance) {
          if (node.matches('.js-homepage-slideshow') && window.slideshow) {
            window.slideshow.buildSliders($(node));
          } else if (node.matches('.products-slider') && window.featuredCollection) {
            window.featuredCollection.buildSliders($(node));
          } else if (node.matches('[data-logo-slider]')) {
            $(node).flickity({cellAlign:'center',pageDots:false,prevNextButtons:true,contain:true,groupCells:true,initialIndex:0});
          }
          instance = window.Flickity && window.Flickity.data(node);
        }
        if (instance) instance.resize();
      });
    }).catch(function (error) {
      console.error('[Strobepro slider recovery]', error);
    }).then(function () { pending = false; });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { window.requestAnimationFrame(repair); });
  }
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('orientationchange', schedule);
  document.addEventListener('lazyloaded', function (event) {
    if (event.target.closest && event.target.closest(selector)) schedule();
  });
  if (document.readyState === 'complete') schedule();
}());
